<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">RBA Report</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row class="px-2">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.fromdate"
                  label="From Date"
                  :rules="FieldRequired('From Date')"
                  @input="filterList.fromdate"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.todate"
                  type="date"
                  :rules="FieldRequired('To Date')"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.risk_level"
                  :items="riskServices"
                  item-text="name"
                  item-value="id"
                  placeholder="Risk Level"
                  label="Select Risk Level"
                  outlined
                  dense
                  class="rounded"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.report_type"
                  :items="reportServices"
                  item-text="name"
                  item-value="id"
                  placeholder="Report Type"
                  label="Select Report Type"
                  outlined
                  dense
                  class="rounded"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  class="rounded"
                  v-model="filterList.nationality"
                  dense
                  outlined
                  label="Nationality"
                  item-text="text"
                  item-value="value"
                  :items="NationalityList"
                  placeholder="Nationality "
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.bene_country"
                  class="rounded"
                  label="Receiver Country"
                  dense
                  outlined
                  :items="CountryList"
                  item-text="text"
                  item-value="value"
                  placeholder="Receiver Country"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                @click="getReportResults()"
                class="mr-2 mt-1"
                color="primary"
                small
                >Get Results
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-4">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Type here to filter the table data."
          hide-details
          class="me-4 mb-3"
          dense
          clearable
        ></v-text-field>
      </v-row>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :search="search"
        :loading="loaderOverlay"
        loading-text="Loading please wait...."
        no-data-text="No data available."
        item-key="Pin_Number"
        dense
        class="mt-3"
      >
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { FieldRequired } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
import reportingService from "@/services/ReportingService/reportingService.js";
import commonService from "@/services/CommonService/commonService.js";
import {
  txnDateType,
  txnStatusReports,
} from "@/utils/ConstantDropdowns/index.js";
export default {
  mixins: [alerts],
  name: "RBA Report",
  data: () => {
    return {
      FieldRequired,
      txnStatusReports: txnStatusReports,
      txnDateType: txnDateType,
      riskServices: [
        {
          name: "All",
          id: 0,
        },
        {
          name: "Low Risk",
          id: 1,
        },
        {
          name: "Medium Risk",
          id: 2,
        },
        {
          name: "High Risk",
          id: 3,
        },
      ],
      reportServices: [
        {
          name: "All",
          id: 0,
        },
        {
          name: "No Of Transaction",
          id: 1,
        },
        // {
        //   name: "No Of Customer",
        //   id: 2,
        // },
      ],
      NationalityList: [],
      CountryList: [],
      headers: [],
      filterList: {
        fromdate: new Date().toISOString().substr(0, 10),
        todate: new Date().toISOString().substr(0, 10),
        nationality: "All",
        bene_country: "All",
        risk_level: 0,
        report_type: 0,
      },
      userList: [],
      senderPartners: [],
      method_options: [
        {
          txt: "All",
          val: "All",
        },
      ],
      search: "",
      userSelectedFilter: "Customer ID",
      loaderOverlay: false,
      valid: false,
    };
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },

  mounted() {
    this.getNationality();
    this.getcountryList();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "RBA Report");
      }
    },
    async partnerPaymentMode(parent_partner_id) {
      try {
        const response = await partnerService.getAllPaymentsbyPartnerId(
          parent_partner_id
        );
        if (response.data.status_code === 200) {
          this.method_options = response.data.data.map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
          this.method_options.unshift({
            txt: "All",
            val: "All",
          });
        } else {
          this.method_options = [];
        }
        console.log("Payment Modes", response);
      } catch (e) {
        console.error(e);
      }
    },

    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getAllSenderPartners();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          this.senderPartners.unshift({
            txt: "All",
            val: "All",
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getReportResults() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const response = await reportingService.getrbaReport(this.filterList);
          if (response.status === 200) {
            this.loaderOverlay = false;
            const ObjKeys = Object.keys(response.data.data[0]);
            this.headers = ObjKeys.map((ele) => {
              return {
                text: ele,
                value: ele,
                sortable: false,
              };
            });
            this.userList = response.data.data;
          } else {
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.loaderOverlay = false;
          console.error(error);
        }
      }
    },

    async getNationality() {
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.NationalityList = response.data.data.map((i) => {
            return { text: i.nationality, value: i.iso_alpha3 };
          });
          this.NationalityList.unshift({
            text: "All",
            value: "All",
          });
          console.log("Nationalty", this.NationalityList);
        } else {
          this.NationalityList == [];
        }
      } catch (error) {
        this.NationalityList = [];
        console.error(error);
      }
    },
    async getcountryList() {
      try {
        const response = await commonService.getBeneficiaryCountryList();
        if (response.data.status_code === 200) {
          this.CountryList = response.data.data.map((i) => {
            return { text: i.name, value: i.isoAlpha3 };
          });
          this.CountryList.unshift({
            text: "All",
            value: "All",
          });
          console.log("CountryList", this.CountryList);
        } else {
          this.CountryList == [];
        }
      } catch (error) {
        this.CountryList = [];
        console.error(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
